import { TournamentMember } from "../../domain/entities/TournamentMember"

interface ContructorParams {
	id: number
	email: string
	name: string
	surname: string
	team: number
}

export class TournamentMemberModel {
	public id: number
	public email: string
	public name: string
	public surname: string
	public team: number

	constructor(params: ContructorParams) {
		this.id = params.id
		this.email = params.email
		this.name = params.name
		this.surname = params.surname
		this.team = params.team
	}

	static fromRawJson = (rawJson: any): TournamentMemberModel => {
		const { id, email, name, surname, team } = rawJson
		return new TournamentMemberModel({
			id,
			email,
			name,
			surname,
			team
		})
	}

	static fromDomain = (member: TournamentMember): TournamentMemberModel => {
		return new TournamentMemberModel(member)
	}
}

declare module "./TournamentMemberModel" {
	interface TournamentMemberModel {
		toDomain(): TournamentMember
	}
}

TournamentMemberModel.prototype.toDomain = function (): TournamentMember {
	const data = this
	return new TournamentMember({
		...data
	})
}
